import React from "react";

function Home() {
  return (
    <div className="container mt-4 text-center">
      <h1 className="fw-bold">Welcome to Barbara PH Properties</h1>
      <p className="lead text-muted">
        Barbara PH Properties is your trusted partner in finding the perfect
        home. We specialize in showcasing carefully selected properties across
        the Philippines, from cozy starter houses to luxurious estates. Our
        mission is to make the journey to homeownership simple, transparent, and
        rewarding.
      </p>

      <p>
        Explore our featured listings, discover prime locations, and connect
        with us to turn your dream of owning a home into reality. With Barbara
        PH Properties, your future begins here.
      </p>
      <img
        src="/images/banner.jpg" // ✅ Replace with your actual banner image
        alt="Barbara PH Properties banner showcasing beautiful homes"
        className="img-fluid rounded shadow-sm mt-3"
      />
    </div>
  );
}

export default Home;
